import React from 'react';

import type { CourseDto } from '@/application/interfaces/pegasus.gateway';

import CourseItem from '../course-item/CourseItem';
import SimpleSlider from '../simple-slider';

type Props = {
  courses: CourseDto[];
};

const CoursesSlider: React.FC<Props> = ({ courses }) => {
  return (
    <SimpleSlider>
      {courses.map((course) => (
        <CourseItem key={course.guid} course={course} />
      ))}
    </SimpleSlider>
  );
};

export default CoursesSlider;
